import React, { FC, ReactNode } from 'react';
import { Map } from 'immutable';

import type { ImmutableRenter } from 'src/types/user/User';
import { ImmutableUser } from 'src/types/user/User';
import getClassName from 'src/common/utils/getClassName';
import Avatar from '../../../../common/components/Avatar';
import s from './UserBlock.module.scss';

type UserBlockProps = {
  children: ReactNode;
  classNameModifier?: string;
  user: ImmutableUser | ImmutableRenter;
};

const UserBlock: FC<UserBlockProps> = ({ children, classNameModifier, user = Map() }) => (
  <div
    className={s.root}
  >
    {!user.isEmpty() && (
      <Avatar
        user={user.toJS()}
        size="medium"
      />
    )}
    <div
      className={getClassName(s, 'content', classNameModifier)}
      data-test="user-block-text"
    >
      {children}
    </div>
  </div>
);

export default UserBlock;
